<template>
    <div>
        <h4>Autorización previa</h4>
        <div class="card col-12 col-sm-12 m-sm-auto">
            <div class="card-body">
                <div class="card-text">
                    <div class="row">
                        <!-- Informacion de la persona -->
                        <div class="col-12 col-sm">
                            <div class="form-row">
                                <app-form-text-input
                                    label="Documento"
                                    v-model="person.document"
                                    :required="true"
                                    :hasError="$v.person.document.$error"
                                    errorMessage="Escriba el documento"
                                    @input="$v.person.document.$touch()"
                                    @change="searchPerson"
                                />
                            </div>
                            <div class="form-row">
                                <app-form-text-input
                                    label="Nombre"
                                    :required="true"
                                    :hasError="$v.person.name.$error"
                                    errorMessage="Escribia el nombre"
                                    @input="$v.person.name.$touch()"
                                    v-model="person.name"
                                />
                            </div>
                            <div class="form-row">
                                <app-form-select-input
                                    label="Tipo de visitante"
                                    :options="visitorTypes"
                                    v-model="authorize.visitorTypeId"
                                    :hasError="
                                        $v.authorize.visitorTypeId.$error
                                    "
                                    errorMessage="seleccione el tipo de visitante"
                                    @change="
                                        $v.authorize.visitorTypeId.$touch()
                                    "
                                    :required="true"
                                />
                            </div>
                        </div>
                        <div class="col-12 col-sm">
                            <div class="form-row">
                                <div>
                                    <app-autocomplete
                                        id="authoridedBy"
                                        label="Destino"
                                        type="people_structures"
                                        :required="true"
                                        v-model="destinationObject"
                                        @change="
                                            $v.authorize.destinationId.$touch()
                                        "
                                        :hasError="
                                            $v.authorize.destinationId.$error
                                        "
                                        errorMessage="Debe especificar el destino"
                                    />
                                </div>
                            </div>
                            <div class="form-row">
                                <div>
                                    <app-autocomplete
                                        id="authorizePerson"
                                        :required="true"
                                        @change="
                                            $v.authorize.authorizedById.$touch()
                                        "
                                        label="Persona que autoriza"
                                        type="people"
                                        v-model="approvedByObject"
                                        :hasError="
                                            $v.authorize.authorizedById.$error
                                        "
                                        errorMessage="Debe especificar quien autoriza"
                                    />
                                </div>
                            </div>
                            <div class="form-row">
                                <app-date-time-picker
                                    id="due-date"
                                    label="Fecha de vigencia"
                                    v-model="authorize.validityDate"
                                    :with-time="false"
                                >
                                </app-date-time-picker>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <app-form-textarea-input
                                label="Notas"
                                v-model="authorize.notes"
                            ></app-form-textarea-input>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import vigilanceRepository from '../../../repositories/vigilance.repository'
import authorizeRepository from '../../../repositories/authorize.repository'
import peopleRepository from '../../../repositories/people.repository'
import DateTimePicker from '../../UI/Controls/DateTimePicker/DateTimePicker.vue'
import FormTextInput from '../../UI/Controls/Forms/FormTextInput.vue'
import FormTextareaInput from '../../UI/Controls/Forms/FormTextareaInput.vue'
import FormSelectInput from '../../UI/Controls/Forms/FormSelectInput.vue'
import Autocomplete from '../../UI/Controls/Autocomplete/Autocomplete.vue'
import { required, numeric } from 'vuelidate/lib/validators'
export default {
    components: {
        appFormTextInput: FormTextInput,
        appFormSelectInput: FormSelectInput,
        appAutocomplete: Autocomplete,
        appDateTimePicker: DateTimePicker,
        appFormTextareaInput: FormTextareaInput,
    },

    props: {
        onSave: {
            type: Function,
        },
    },

    watch: {
        destinationObject(val) {
            if (val) {
                if (!!val.structure_type) {
                    this.authorize.destinationId = val.id
                } else {
                    this.authorize.destinationId = val.structure_id
                }
            }
        },
        approvedByObject(val) {
            if (val) {
                if (val.id == 0) {
                    toastr.error('No existe esta persona')
                    this.authorize.authorizedById = ''
                    this.approvedByObject = ''
                    this.$bus.$emit('authorizePerson.reset')
                } else {
                    this.authorize.authorizedById = val.id
                }
            } else {
                this.authorize.authorizedById = ''
                this.approvedByObject = ''
            }
        },
    },

    data() {
        return {
            authorize: {
                authorizedById: '',
                destinationId: '',
                personId: '',
                structureId: '',
                userId: '',
                visitorTypeId: '',
                validityDate: null,
                notes: '',
            },
            person: {
                document: '',
                name: '',
                clientId: '',
            },
            visitorTypes: [],
            destinationObject: '',
            approvedByObject: '',
        }
    },

    validations: {
        authorize: {
            authorizedById: { required },
            destinationId: { required },
            visitorTypeId: { required },
        },
        person: {
            document: { required, numeric },
            name: { required },
        },
    },

    methods: {
        registerAuthorization() {
            this.$v.$touch()
            if (this.$v.$invalid) {
                toastr.error(
                    'Debe diligenciar correctamente todos los campos obligatorios'
                )
                return false
            }

            const payload = {
                ...this.authorize,
                ...this.person,
                clientId: this.client.id,
            }

            const ar = Object.assign({}, authorizeRepository)
            ar.saveAuthorization(payload)
                .then(data => {
                    if (data.status) {
                        this.clear()
                        toastr.success(data.msg)
                        typeof this.onSave === 'function' && this.onSave()
                    }
                })
                .catch(error => {
                    toastr.error('Error al crear autorización previa')
                })
        },
        loadVisitorTypes() {
            const vr = Object.assign({}, vigilanceRepository)
            vr.getVisitorTypes()
                .then(
                    data =>
                        (this.visitorTypes = data.filter(
                            item =>
                                !!item.selectable && item.group === 'peatonal'
                        ))
                )
                .catch(error =>
                    toastr.error(
                        'Ocurrió un error al cagar los tipos de visitante'
                    )
                )
        },
        async searchPerson() {
            const { data } = await repo.get('people', {
                document: this.person.document,
                client: this.client.id,
            })
            if (!data.length) return

            const person = data[0]
            this.person.document = person.document
            this.person.name = person.name
            this.person.clientId = person.client_id
            this.authorize.personId = person.id
        },
        clear() {
            this.person = {
                document: '',
                name: '',
            }
            this.authorize.personId = ''
            this.authorize.visitorTypeId = ''
            this.authorize.notes = ''
            this.authorize.destinationId = ''
            this.authorize.authorizedById = ''
            this.authorize.validityDate = null
            this.destinationObject = ''
            this.approvedByObject = ''
            this.$bus.$emit('authorizePerson.reset')
            this.$bus.$emit('authoridedBy.reset')
            this.$bus.$emit('due-date.clear')
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },
        setStructure() {
            if (this.user.profile.client_required) {
                this.authorize.structureId = this.accessPoint.id
            } else {
                const accessPoints = this.client.structures
                    .filter(s => !!s.structure_type.access_point)
                    .sort((a, b) => a.id - b.id)
                !accessPoints.empty &&
                    (this.authorize.structureId = accessPoints[0].id)
                accessPoints.empty &&
                    toastr.error(
                        'Primero debe configurar un punto de acceso para crear autorizaciones'
                    )
            }
        },
    },

    created() {
        this.loadVisitorTypes()
        this.setStructure()
        this.authorize.userId = this.user.id
        this.person.clientId = this.client.id
        this.$bus.$on('authorization-form.save', this.registerAuthorization)
        this.$bus.$on('authorization-form.clean', this.clear)
    },

    beforeDestroy() {
        this.$bus.$off('authorization-form.save')
    },
}
</script>
